import { ArrowBackFilled } from '@/assets/icons';
import logoSvg from '@/assets/logo-color.svg';
import logoSvgArabic from '@/assets/logo-color-arabic.svg';
import { Button } from '@opaz/ui-components';
import { AxiosError } from 'axios';
import { ErrorResponse } from 'oidc-client-ts';
import { useTranslation } from 'react-i18next';
import { FormErrorAlert } from './form-error-alert';
import { LanguageSwitcher } from './language-switcher';
import { Link } from '@tanstack/react-router';

type AuthFormProps = {
  children: React.ReactNode;
  onBack?: () => void;
  error: AxiosError | ErrorResponse | null | undefined;
};

export const AuthForm = ({ children, onBack, error }: AuthFormProps) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="p-6 flex gap-6 bg-states-base-bg xl:min-w-[1200px] h-[100vh] justify-center">
      <div className="flex-1 max-w-[764px] relative">
        <div className="flex justify-between h-[60px] mb-4 sm:mb-20">
          <div>
            {onBack && (
              <Button variant="ghost" className="no-underline" onClick={onBack}>
                <ArrowBackFilled dir={i18n.dir()} />
                {t('common.back')}
              </Button>
            )}
          </div>

          <LanguageSwitcher variant="ghost" showIcon={true} showText={true} />
        </div>
        <div className="mx-auto md:w-[500px]">
          <Link className="inline-block mb-10" to="/">
            <img className="h-[36px] sm:h-[48px]" src={i18n.language === 'ar' ? logoSvgArabic : logoSvg}></img>
          </Link>

          <FormErrorAlert className="mb-10" error={error} />

          {children}
        </div>
      </div>

      <div className="xl:flex flex-1 max-w-[764px] hidden">
        <div className="relative flex flex-1 w-full min-w-[600px] max-h-[912px] rounded-xl bg-cover bg-no-repeat bg-[url('@/assets/login-image.png')]">
          <div className="absolute bottom-0 p-12">
            <img className="sr-only" alt={t('login.image.alt')} />

            <p className="text-brand-contrast font-bold text-3xl mb-4">{t('login.image.title')}</p>

            <span className="block font-bold text-brand-contrast text-base">{t('login.image.personName')}</span>
            <span className="block text-brand-contrast text-base">{t('login.image.personTitle')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
